
export default {
  props: {
    wapSettings: {
      // 全部的筛选条件
      type: Array,
      default: () => []
    },
    stepshow: {
      // 步骤
      type: String,
      default: ''
    },
    filterItems: {
      // 选择的条件
      type: Array,
      default: () => []
    },
    currencySymbol: {
      // 货币
      type: String,
      default: ''
    },
    filterdata: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    },
    wapshow: {
      type: Boolean,
      default: false
    },
    freedata: {
      type: Array,
      default: () => []
    },
    freedata1: {
      type: Array,
      default: () => []
    },
    freedata14: {
      type: Array,
      default: () => []
    },
    freedata141: {
      type: Array,
      default: () => []
    },
    freedata5: {
      type: Array,
      default: () => []
    },
    freedata51: {
      type: Array,
      default: () => []
    },
    freedata6: {
      type: Array,
      default: () => []
    },
    freedata61: {
      type: Array,
      default: () => []
    },
    freedata7: {
      type: Array,
      default: () => []
    },
    freedata71: {
      type: Array,
      default: () => []
    },
    freedata9: {
      type: Array,
      default: () => []
    },
    freedata91: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      freedata11: this.freedata,
      freedata1411: this.freedata14,
      freedata511: this.freedata5,
      freedata611: this.freedata6,
      freedata711: this.freedata7,
      freedata911: this.freedata9,
      elearr: [],
      active: 0
    }
  },
  watch: {
    wapshow(val) {
      this.setelefn()
      console.log(val, 8886)
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    freedata(val) {
      this.freedata11 = val
    },
    freedata14(val) {
      this.freedata1411 = val
    },
    freedata5(val) {
      this.freedata511 = val
    },
    freedata6(val) {
      this.freedata611 = val
    },
    freedata7(val) {
      this.freedata711 = val
    },
    freedata9(val) {
      this.freedata911 = val
    }
  },
  mounted() {
    this.setelefn()
    document.getElementById('wapSettings').addEventListener('scroll', () => {
      // console.log(document.getElementById('wapSettings').scrollTop, 9978)
      const top = document.getElementById('wapSettings').scrollTop
      this.elearr?.forEach((item, index) => {
        if (top >= item) {
          this.active = index
        }
      })
    })
  },
  methods: {
    setelefn() {
      const top = document.getElementById('wapSettings').offsetTop + 12
      const ele = document.getElementsByClassName('prop-tab')
      this.elearr = []
      for (let i = 0; i < ele?.length; i++) {
        const h = ele[i].offsetTop - top
        this.elearr.push(h)
      }
    },
    tabwapSettings(index) {
      this.active = index
      document.getElementById('wapSettings').scrollTop = this.elearr[index]
    },
    setchangefn1(val) {
      this.$emit('setchangefn1', val)
    },
    setchangefn2(val) {
      this.$emit('setchangefn2', val)
    },
    setchangefn3(index, indexs, val) {
      console.log('setchangefn3', index, indexs, val)
      this.$emit('setchangefn3', index, indexs, val)
    },
    hzfn(val) {
      // 后缀
      if (val == 14 || val == 5 || val == 6 || val == 9) {
        return '%'
      } else if (val == 7) {
        return this.$t('22928')
      } else {
        return ''
      }
    },
    filterfn(items, index, indexs) {
      this.$emit('filterfn', items, index, indexs)
    },
    remlvefilterdatafn(item) {
      this.$emit('remlvefilterdatafn', item)
    },
    removeallfn() {
      this.$emit('removeallfn')
    },
    close() {
      this.$emit('close')
    },
    taggerfn(index) {
      this.$emit('taggerfn', index)
      setTimeout(() => {
        this.setelefn()
      }, 200)
    }
  }
}
